import { makeStyles } from "@material-ui/core/styles";

export const HighlightsStyles = makeStyles(() => ({
  button: {
    margin: "20px 0",
  },
}));
